import { Button, Card, CardContent, CardFooter } from '@features/ui';
import { DoubleCheckIcon } from '@features/ui/icons';
import { TPackages } from '@src/types';
import { FC } from 'react';

interface FeaturesCardProps {
  features?: TPackages;
}

export const FeatureCard: FC<FeaturesCardProps> = ({ features }) => {
  const accountBenefits = features?.account_benefits?.split('\n') ?? [];

  return (
    <Card className="bg-card px-1 py-5 justify-between w-full lg:w-1/3">
      <div>
        <CardContent className="pt-6 space-y-[9px]">
          {accountBenefits.map((item, index) => (
            <div key={`${item}_${index}`} className="flex items-center gap-3">
              <DoubleCheckIcon />
              <span className="text-xl lg:text-2xl">{item}</span>
            </div>
          ))}
        </CardContent>
      </div>
      <CardFooter className="pt-40">
        <Button
          className="w-full text-base font-bold"
          size={'lg'}
          variant={'gradient'}
        >
          GET FOR $125/MO
        </Button>
      </CardFooter>
    </Card>
  );
};
